import React from 'react';
import { Equation } from '../Equation';
import { Lessons } from '../../Lessons';
import './Test.scss';

/*
  props:
    testName     - section ID, e.g. "4b"
    historyRecord - TestHistory object { testHistoryId, studentId, testName, timestamp, answers }
    onClose      - called when the overlay or close button is clicked
*/
export class TestHistoryView extends React.Component {
  render() {
    const { testName, historyRecord, onClose } = this.props;

    const section = Lessons.getLessonSection(testName);
    if (!section) return null;
    const testPage = section.pages.find(p => p.type === 'test');
    if (!testPage) return null;

    const questions = testPage.testQuestions;
    let answers = [];
    try { answers = JSON.parse(historyRecord.answers); } catch { /* leave empty */ }

    let nCorrect = 0;
    questions.forEach((q, i) => {
      if (parseInt(answers[i], 10) === q.x * q.y) nCorrect++;
    });
    const score = questions.length > 0 ? nCorrect / questions.length : 0;

    const ts = new Date(historyRecord.timestamp);
    const dateStr = `${ts.getMonth() + 1}/${ts.getDate()}/${ts.getFullYear()}`;

    return (
      <div className="cr-modal-overlay cr-history-overlay" onClick={onClose}>
        <div className="cr-modal cr-history-modal" onClick={e => e.stopPropagation()}>
          <div className="cr-modal-header">
            <span className="cr-modal-title">
              {section.name} &nbsp;|&nbsp; {dateStr}
            </span>
            <div className="cr-modal-header-actions">
              <button className="cr-print-button" onClick={window.print}>Print</button>
              <button className="cr-modal-close" onClick={onClose}>&times;</button>
            </div>
          </div>
          <div className="cr-modal-body cr-history-body">
            <div className="testContainer">
              <div className="instructions cr-history-instructions">
                <div className="cr-history-stat-label">CORRECT</div>
                <div className="cr-history-stat-value">{nCorrect} / {questions.length}</div>
                <div className="cr-history-stat-label">SCORE</div>
                <div className="cr-history-stat-value">{Math.round(score * 100)}%</div>
              </div>
              <div className={`questions questions-${questions.length}`}>
                {questions.map((question, index) => {
                  const studentAns = answers[index] != null && String(answers[index]) !== 'null' ? String(answers[index]) : '';
                  const isCorrect = parseInt(studentAns, 10) === question.x * question.y;
                  return (
                    <div key={`hq-${index}`}>
                      <Equation
                        className="testEquation"
                        testComplete={true}
                        initialAnswer={studentAns}
                        equation={{
                          x: { value: question.x },
                          y: { value: question.y },
                        }}
                        reportResult={() => {}}
                      />
                      <div className="correctAnswer">
                        {isCorrect ? '\u00a0' : question.x * question.y}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
